<template>
  <div>
    <h3 class="title mb-0">MULTI EMPRESAS</h3>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12" v-for="service in services" :key="service.id_pay">
          <div class="service-card">
            <div class="service-header">
              <strong>ID: {{ service.id_pay }}</strong>
              <span class="service-type">{{ service.type }}</span>
            </div>
            <div class="service-details">
              <p><strong>Fecha:</strong> {{ formatDate(service.date) }}</p>
              <p><strong>Monto:</strong> {{ formatPrice(service.value) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '../http'

export default {
  name: 'ME',
  data() {
    return {
      services: []
    }
  },
  created() {
    this.loadServices()
  },
  methods: {
    loadServices() {
      http.get('app/service/me/all')
        .then(res => {
          this.services = Object.values(res.body.services)
        })
        .catch(err => {
          console.error('Error loading ME services:', err)
        })
    },
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleDateString('es-CL')
    },
    formatPrice(price) {
      if (!price) return '$0'
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP'
      }).format(price)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/ME.vue